import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { availabilityService } from '../../services/availabilityService';
import { useNotification } from '../../context/NotificationContext';
import styles from './AvailabilityQuickCopyPage.module.scss';

const AvailabilityQuickCopyPage: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { showNotification } = useNotification();
    const [loading, setLoading] = useState(true);
    const executedRef = useRef(false);

    useEffect(() => {
        if (executedRef.current) return;
        executedRef.current = true;
        
        const copyAvailability = async () => {
            const targetWeekStart = searchParams.get('targetWeek');
            if (!targetWeekStart) {
                showNotification('Falta el parámetro de la semana objetivo.', 'error');
                navigate('/dashboard', { replace: true });
                return;
            }

            try {
                await availabilityService.copyLatestAvailability(targetWeekStart);
                showNotification('¡Tu disponibilidad ha sido copiada con éxito para la próxima semana!', 'success');
                navigate('/availability', { replace: true });
            } catch (error: any) {
                console.error(error);
                showNotification(error.error || 'Ocurrió un error al copiar tu disponibilidad.', 'error');
                navigate('/availability', { replace: true });
            } finally {
                setLoading(false);
            }
        };

        copyAvailability();
    }, [navigate, searchParams, showNotification]);

    if (!loading) {
        return null;
    }

    return (
        <div className={styles.container}>
            <CircularProgress size={60} />
            <h2 className={styles.title}>Copiando tu disponibilidad...</h2>
            <p className={styles.subtitle}>Por favor espera un momento, estamos configurando tus horarios para la próxima semana.</p>
        </div>
    );
};

export default AvailabilityQuickCopyPage;
